import React, { useState, useEffect } from 'react';
import Folder from './Folder';
import CustomFile from './CustomFile';
import { useDispatch } from 'react-redux';
import { uploadToBoxAction } from '../../../store/actions/BoxActions';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import moment from 'moment';
import { getBoxFolders, uploadFile, uploadFileBatch } from '../../../services/BoxService';
import { createFormAction } from '../../../store/actions/FormsActions';
import { checkDataExists, retrieveData } from '../../../services/indexedDBUtils';
import { useAuth } from '../../../context/authContext';

const Explorer = () => {
  const location = useLocation();
  const [currentPath, setCurrentPath] = useState('0');
  const [data, setData] = useState([]);
  const [folderAPISuccess, setFolderAPISuccess] = useState(true);
  const [history, setHistory] = useState([
    {
      path: '0',
      name: 'Root',
    },
  ]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { hasPermission } = useAuth();
  useEffect(() => {
    getBoxFolder('0');
  }, []);

  const handleFolderClick = (path, name) => {
    setCurrentPath(path);
    getBoxFolder(path);
    setHistory([...history, { path: currentPath, name: name }]);
  };

  const uploadFileToBox = async () => {
    const folderId = currentPath || '0'; // Upload to the current folder or root if no folder is selected
    const formData = await retrieveData(parseInt(localStorage.getItem('formData')));
    if (formData) {
      const fileName =
        formData.name + '-' + moment().format('MM-DD-YYYY') + '-' + moment().unix() + '.pdf';
      const payload = {
        data: formData.file,
        folderId: folderId,
        name: fileName,
      };
      try {
        const response = await uploadFile(payload);
        const formDataJSON = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));
        if (formDataJSON) {
          dispatch(createFormAction(formDataJSON, navigate));
        } else {
          navigate('/dashboard');
        }

        console.log('File uploaded successfully:', response.data);
        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          height: 400,
          confirmButtonColor: '#3a7afe',
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Request not submitted',
          text: 'Please contact your admin',
          width: 400,
          height: 400,
          confirmButtonColor: '#3a7afe',
        });
        console.error(
          'Error uploading file:',
          error.response ? error.response.data : error.message
        );
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      navigate('/dashboard');
    }
  };

  const handleUpload = async () => {
    const folderId = currentPath || '0'; // Upload to the current folder or root if no folder is selected
    let pdfContent = new Blob(['no data in form']);
    let formName = 'NULLED';
    if (location.state != null) {
      pdfContent = location.state.pdf;
      formName = location.state.formName;
    }
    dispatch(uploadToBoxAction(pdfContent, folderId, formName));
    Swal.fire({
      icon: 'success',
      title: 'Request submitted',
      text: 'Your request is submitted please wait for approver',
      width: 400,
      height: 400,
      confirmButtonColor: '#3a7afe',
    });
    navigate('/dashboard');
  };
  const getBoxFolder = async (path = '0') => {
    await getBoxFolders(path)
      .then((responseFolders) => {
        setData(responseFolders.data.entries || []);
        setFolderAPISuccess(true);
      })
      .catch((error) => {
        setData([]);
        console.log('box error in folder', error);
      });
  };

  const handleBackClick = () => {
    if (history.length === 0) {
      return false;
    }
    const newHistory = [...history];
    const previousPath = newHistory.pop();
    setHistory(newHistory);
    setCurrentPath(previousPath.path || '0');
    getBoxFolder(previousPath.path);
  };

  const handleUploadBatch = async () => {
    const formData = await retrieveData(parseInt(localStorage.getItem('formDataJSON')));

    if (formData) {
      const payload = {
        data: formData.dynamicFields,
      };
      try {
        const response = await uploadFileBatch(payload);
        if (Array.isArray(formData.dynamicFields)) {
          formData.dynamicFields.forEach((data, index) => {
            if (index == formData.dynamicFields - 1) {
              dispatch(createFormAction({ ...formData, ['dynamicFields']: data }, navigate));
            } else {
              dispatch(createFormAction({ ...formData, ['dynamicFields']: data }, undefined));
            }
          });
        } else {
          navigate('/dashboard');
        }

        console.log('File uploaded successfully:', response.data);
        Swal.fire({
          icon: 'success',
          title: 'Request submitted',
          text: 'Your request is submitted please wait for approver',
          width: 400,
          height: 400,
          confirmButtonColor: '#3a7afe',
        }).then(() => {
          navigate('/dashboard');
        });
      } catch (error) {
        Swal.fire({
          icon: 'error',
          title: 'Request not submitted',
          text: 'Please contact your admin',
          width: 400,
          height: 400,
          confirmButtonColor: '#3a7afe',
        });
        console.error(
          'Error uploading file:',
          error.response ? error.response.data : error.message
        );
      }
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Data not existed',
        text: 'Please contact your admin',
        width: 400,
        height: 400,
        confirmButtonColor: '#3a7afe',
      });
      navigate('/dashboard');
    }
  };
  return (
    <>
      {!hasPermission('box-folders', ['show']) && folderAPISuccess == true ? (
        <button type="button" className="btn btn-primary" onClick={handleUploadBatch}>
          Submit all Forms
        </button>
      ) : (
        ''
      )}
      {hasPermission('box-folders', ['show']) && folderAPISuccess == true ? (
        <div className="container flex-grow-1 light-style container-p-y">
          <div className="container-m-nx container-m-ny bg-lightest mb-3">
            <ol className="breadcrumb text-big container-p-x py-3 m-0">
              <li className="breadcrumb-item">
                <Link to={'/dashboard'}>Dashboard</Link>
              </li>
              {history.map((item, index) => (
                <li key={index} className="breadcrumb-item">
                  <Link key={index} color="inherit">
                    {item.name}
                  </Link>
                </li>
              ))}
            </ol>

            <hr className="m-0" />
            {/* <button onClick={handleLogin}>Login with Box</button> */}

            <div className="file-manager-actions container-p-x py-2">
              <div>
                <div className="btn-group btn-group-toggle" data-toggle="buttons">
                  <label className="btn btn-default icon-btn md-btn-flat active">
                    <input
                      type="radio"
                      name="file-manager-view"
                      value="file-manager-col-view"
                      defaultChecked
                    />
                    <span className="ion ion-md-apps"></span>
                  </label>
                  <label className="btn btn-default icon-btn md-btn-flat">
                    <input type="radio" name="file-manager-view" value="file-manager-row-view" />
                    <span className="ion ion-md-menu"></span>
                  </label>
                </div>
              </div>
            </div>
          </div>

          <div className="file-manager-container file-manager-col-view">
            <div className="file-manager-row-header">
              <div className="file-item-name pb-2">Filename</div>
              <div className="file-item-changed pb-2">Changed</div>
            </div>
            <div
              className="file-item"
              onClick={handleBackClick}
              style={history.length === 0 ? { pointerEvents: 'none' } : {}}
            >
              <div className={`file-item-icon fas fa-level-up-alt text-secondary`}></div>
              <div className="file-item-name" onClick={handleBackClick}>
                ..
              </div>
            </div>
            {data && data.length > 0 && (
              <>
                {data
                  .filter((entry) => entry.type === 'folder')
                  .map((folder) => (
                    <Folder key={folder.id} folder={folder} onClick={handleFolderClick} />
                  ))}
                {data
                  .filter((entry) => entry.type === 'file')
                  .map((file) => (
                    <CustomFile key={file.id} file={file} />
                  ))}
              </>
            )}
          </div>
          <hr className="mt-5 mb-3" />
          <div className="row">
            <div className="col-2 offset-10">
              <button onClick={uploadFileToBox} className="btn btn-primary float-right">
                Submit here
              </button>
            </div>
          </div>
        </div>
      ) : (
        ''
      )}
      {folderAPISuccess == false ? <></> : ''}
    </>
  );
};

export default Explorer;
